<button *ngIf="shouldShowButton && !!buttonIcon" mat-button color="primary" (click)="perform()">
    <mat-icon class="icon-display-size">{{ buttonIcon }}</mat-icon>
</button>
